// Component
export { Alert } from "./components/Alert/Alert";
export { AlertProvided } from "./components/Alert/AlertProvided";
export { AlertProvider, useAlertContext } from "./components/Alert/Context";
export { Avatar } from "./components/Avatar/Avatar";
export { Form } from "./components/Form/Form";
export { HorizontalProductCard } from "./components/HorizontalProductCard/HorizontalProductCard";
export { InfoBlock } from "./components/InfoBlock/InfoBlock";
export { Input } from "./components/Input/Input";
export { LoadingOverlay } from "./components/LoadingOverlay/LoadingOverlay";
export { ProductRibbon } from "./components/ProductRibbon/ProductRibbon";
export { Ribbon } from "@shared/ui.primitives";
export { ProgressBar } from "./components/ProgressBar/ProgressBar";
export { PromoBanner } from "./components/PromoBanner/PromoBanner";
export { PromoSection } from "./components/PromoSection/PromoSection";
export { PromoTile } from "./components/PromoTile/PromoTile";
export { Rating } from "./components/Rating/Rating";
export { ShadeSelector } from "./components/ShadeSelector/ShadeSelector";
export { StrikethroughPrice } from "./components/StrikethroughPrice/StrikethroughPrice";
export { toProductCardData } from "./utils/productCard";
export { trustPilotConfig } from "./components/TrustPilotWidgets/constants";
export { TrustPilotRatingWidget } from "./components/TrustPilotWidgets/TrustPilotRatingWidget";
export { TrustPilotReviewWidget } from "./components/TrustPilotWidgets/TrustPilotReviewWidget";
export { VerticalProductCard } from "./components/VerticalProductCard/VerticalProductCard";

// Types
export * from "./utils/types";
export type { AlertProps, AlertVariant } from "./components/Alert/Alert";
export type { ProductCardDataType } from "./components/VerticalProductCard/components/types";
export type { ProductCardDataType as HorizontalProductCardDataType } from "./components/HorizontalProductCard/components/types";
export type { PromoSectionProps } from "./components/PromoSection/PromoSection";
export type { PromoTileProps } from "./components/PromoTile/PromoTile";

// Why is this here?
export { useRouter } from "./utils/router";
